import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import RegisterWrapper from "../../Components/Wrappers/RegisterWrapper";
import Button from "../../UI/Button";
import Input from "../../UI/Input";
import usePasswordToggle from "../../Global/Hooks/togglePassword";
import useEmailValidation from "../../Global/Hooks/emailValidation";
import usePasswordValidation from "../../Global/Hooks/passwordValidation";
import useLoginApi from "../../Global/Api/Login/loginApi";

const Login = () => {
  const navigate = useNavigate();
  const emailValidation = useEmailValidation();
  const passwordValidation = usePasswordValidation();
  const passwordToggle = usePasswordToggle();
  const loginApi = useLoginApi();

  const handleSubmit = (e) => {
    e.preventDefault();
    loginApi.send({
      email: emailValidation.value,
      password: passwordValidation.value,
    });
  };

  const handleEmailChange = (event) => {
    emailValidation.handleChange(event);
    emailValidation.validateEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    passwordValidation.handleChange(event);
  };

  const isButtonDisabled = !(
    emailValidation.isValid && passwordValidation.isValid
  );

  useEffect(() => {
    if (localStorage.getItem("techsbook_customer_portal_token")?.length > 0) {
      navigate("/");
    }
  }, []);

  return (
    <RegisterWrapper image="/assets/images/register-1.svg">
      <form onSubmit={handleSubmit} className="register-form">
        <h1 className="register__title">Log in to your account</h1>
        <div className="register__input mt24">
          <Input
            label="Email"
            placeholder="Enter email"
            type="email"
            id="email"
            name="email"
            value={emailValidation.value}
            handleChange={handleEmailChange}
          />
        </div>
        <div className="register__input mt20 ">
          <Input
            id="password"
            label="Password"
            placeholder="Enter password"
            type={passwordToggle.type}
            name="password"
            value={passwordValidation.value}
            toggleType={passwordToggle.toggleType}
            icon={passwordToggle.icon}
            handleChange={handlePasswordChange}
          />
        </div>
        <div className="register__row mt20">
          <div></div>
          <NavLink to="/forgot-password" className="register__link">
            Forgot Password?
          </NavLink>
        </div>
        <div className="register__btn mt24">
          <Button
            text="Log in"
            type="primary"
            disabled={isButtonDisabled}
            topPadding={12}
            bottomPadding={12}
          />
        </div>
      </form>
      <div className="register__footer mt24">
        Don't have an account?{" "}
        <NavLink to="/select-country" className="register__link">
          Sign up
        </NavLink>
      </div>
    </RegisterWrapper>
  );
};

export default Login;
